export default "__VITE_ASSET__BYQvMFHR__"